
function TokenExpired(props) {
    return (
        <main className="container">
            <div className="d-flex vh-100 align-items-center justify-content-center">
                <div className="alert alert-primary" role="alert">
                    Aika umpeutui, kirjaudu uudelleen!
                </div>
            </div>
        </main>
    );
  }
  
  
  export default TokenExpired;